export function truncateText(text = "", maxLength = 0) {
  if (!maxLength) return text;

  return text.length > maxLength
    ? `${text.substring(0, maxLength)}...`
    : text;
}